<template>
  <right-banner-template :title="entry">
    <div class="detail">
      <!-- <p class="title">{{ title }}</p>
      <div class="date-container">
        <div class="img-container">
          <img @contextmenu.prevent src="../../assets//clock-icon.svg" id="icon">
        </div>
        <p class="date">{{ formatDate(createdAt) }}</p>
      </div> -->
      <div v-html="content" class="ql-editor"></div>
      <!-- <p class="content">{{ content }}</p> -->
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['entry', 'content'],
  methods: {
    formatDate (idate) {
      const date = new Date(idate)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<style scoped>
  .ql-editor{
    height: 100%;
  }

  .detail {
    margin-bottom: 40px;
  }

  .detail .title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .date-container {
    display: flex;
  }

  #icon {
    width: 15px;
    height: 15px;
  }

  .img-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .detail .date {
    color: #ababab;
    font-size: 13px;
    margin-left: 5px;
  }

  .detail .content {
    margin-top: 40px;
  }
</style>
